import { render } from "./PhotoList.vue?vue&type=template&id=12687885&scoped=true"
import script from "./PhotoList.vue?vue&type=script&lang=js"
export * from "./PhotoList.vue?vue&type=script&lang=js"

import "./PhotoList.vue?vue&type=style&index=0&id=12687885&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12687885"]])

export default __exports__